/* Homepage: hero attribution + showcase card carousels / lightbox */
(function () {
    if (!document.body.classList.contains('home-template')) {
        return;
    }

    var ATTR_KEYS = [
        'source',
        'campaign',
        'ref',
        'utm_source',
        'utm_medium',
        'utm_campaign',
        'utm_content',
        'utm_term',
    ];

    function mergeAttributionParams(targetUrl) {
        try {
            var url = new URL(targetUrl, window.location.origin);
            var pageParams = new URLSearchParams(window.location.search);
            var firstTouch = null;
            try {
                firstTouch = window.YOBY_firstTouch || JSON.parse(sessionStorage.getItem('yoby_first_touch') || 'null');
            } catch (e) {
                firstTouch = window.YOBY_firstTouch || null;
            }
            ATTR_KEYS.forEach(function (key) {
                if (url.searchParams.get(key)) return;
                var fromPage = pageParams.get(key);
                if (fromPage) {
                    url.searchParams.set(key, fromPage);
                    return;
                }
                if (!firstTouch || typeof firstTouch !== 'object') return;
                var camel =
                    key.indexOf('utm_') === 0
                        ? 'utm' + key.slice(4).charAt(0).toUpperCase() + key.slice(5)
                        : key;
                var fromTouch = firstTouch[key] || firstTouch[camel];
                if (fromTouch) url.searchParams.set(key, String(fromTouch));
            });
            return url.pathname + url.search + url.hash;
        } catch (e) {
            return targetUrl;
        }
    }

    function applyHeroAttribution() {
        document.querySelectorAll('[data-yoby-preserve-attribution]').forEach(function (el) {
            var href = el.getAttribute('href');
            if (!href || href.charAt(0) === '#') return;
            el.setAttribute('href', mergeAttributionParams(href));
            var canonical = el.getAttribute('data-yoby-href-canonical');
            if (canonical) {
                el.setAttribute('data-yoby-href-canonical', mergeAttributionParams(canonical));
            }
        });
    }

    function bindHeroTrack() {
        document.querySelectorAll('[data-yoby-track]').forEach(function (el) {
            el.addEventListener('click', function () {
                var name = el.getAttribute('data-yoby-track');
                if (!name) return;
                try {
                    window.dispatchEvent(
                        new CustomEvent('yoby:track', {
                            detail: { event: name, href: el.getAttribute('href') || '' },
                        }),
                    );
                } catch (e) {
                    /* ignore */
                }
            });
        });
    }

    applyHeroAttribution();
    bindHeroTrack();
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            applyHeroAttribution();
            bindHeroTrack();
        });
    }
    window.addEventListener('yoby:localechange', applyHeroAttribution);
})();

(function () {
    if (!document.body.classList.contains('home-template')) {
        return;
    }

    var track = document.querySelector('.yoby-showcase-track');
    if (!track) {
        return;
    }

    var INTERVAL_MS = 5200;
    var SHOWCASE_FALLBACK = 'en';
    var SHOWCASE_LANG_RE = /\/showcase\/(?:en|it|fr|de|es|pt|nl)\//;

    function showcaseLocale() {
        if (window.YOBY_i18n && typeof window.YOBY_i18n.getLocale === 'function') {
            var loc = window.YOBY_i18n.getLocale();
            return loc === 'nl' ? SHOWCASE_FALLBACK : loc;
        }
        return SHOWCASE_FALLBACK;
    }

    function swapShowcaseLocale(url, loc) {
        return String(url || '').replace(SHOWCASE_LANG_RE, '/showcase/' + loc + '/');
    }

    function applyShowcaseLocale(locale) {
        var loc = locale === 'nl' ? SHOWCASE_FALLBACK : locale;

        track.querySelectorAll('[data-yoby-showcase-id]').forEach(function (img) {
            var pngUrl = swapShowcaseLocale(img.getAttribute('src') || '', loc);
            if (pngUrl) {
                img.src = pngUrl;
                img.setAttribute('data-full-src', pngUrl);
            }
            var picture = img.closest('picture');
            if (!picture) {
                return;
            }
            picture.querySelectorAll('source[data-yoby-showcase-format]').forEach(function (source) {
                source.srcset = swapShowcaseLocale(source.getAttribute('srcset') || '', loc);
            });
        });
    }

    function allSlideButtons() {
        return Array.prototype.slice.call(track.querySelectorAll('.yoby-showcase-slide'));
    }

    function openShowcaseLightbox(index) {
        var slides = allSlideButtons();
        if (!slides.length || typeof PhotoSwipe === 'undefined') {
            return;
        }

        var items = [];
        slides.forEach(function (slide) {
            var img = slide.querySelector('img');
            if (!img) {
                return;
            }
            var card = slide.closest('.yoby-showcase-card');
            var titleEl = card ? card.querySelector('.gh-card-title') : null;
            var fullSrc = img.getAttribute('data-full-src') || img.getAttribute('src');
            items.push({
                src: fullSrc,
                msrc: fullSrc,
                w: parseInt(img.getAttribute('width'), 10) || 1280,
                h: parseInt(img.getAttribute('height'), 10) || 720,
                el: img,
                title: titleEl ? titleEl.textContent : '',
            });
        });

        var pswpElement = document.querySelector('.pswp');
        if (!pswpElement || !items.length) {
            return;
        }

        var gallery = new PhotoSwipe(
            pswpElement,
            PhotoSwipeUI_Default,
            items,
            {
                bgOpacity: 0.92,
                closeOnScroll: true,
                fullscreenEl: false,
                history: false,
                index: Math.max(0, Math.min(index, items.length - 1)),
                shareEl: false,
                zoomEl: true,
                getThumbBoundsFn: function (idx) {
                    var thumbnail = items[idx].el;
                    var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
                    var rect = thumbnail.getBoundingClientRect();
                    return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
                },
            }
        );
        gallery.init();
    }

    function setSlide(carousel, index) {
        var slides = Array.prototype.slice.call(carousel.querySelectorAll('.yoby-showcase-slide'));
        var dots = Array.prototype.slice.call(carousel.querySelectorAll('.yoby-showcase-dot'));
        if (!slides.length) {
            return;
        }
        var next = ((index % slides.length) + slides.length) % slides.length;
        slides.forEach(function (slide, i) {
            var active = i === next;
            slide.classList.toggle('is-active', active);
            if (active) {
                slide.removeAttribute('hidden');
            } else {
                slide.setAttribute('hidden', '');
            }
        });
        dots.forEach(function (dot, i) {
            var active = i === next;
            dot.classList.toggle('is-active', active);
            dot.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        carousel.dataset.activeIndex = String(next);
    }

    function initCarousel(carousel) {
        var slides = Array.prototype.slice.call(carousel.querySelectorAll('.yoby-showcase-slide'));
        var dotsHost = carousel.querySelector('.yoby-showcase-dots');
        if (slides.length < 2) {
            if (dotsHost) {
                dotsHost.hidden = true;
            }
            return;
        }

        if (dotsHost) {
            dotsHost.innerHTML = '';
            slides.forEach(function (_slide, i) {
                var dot = document.createElement('button');
                dot.type = 'button';
                dot.className = 'yoby-showcase-dot' + (i === 0 ? ' is-active' : '');
                dot.setAttribute('role', 'tab');
                dot.setAttribute('aria-label', String(i + 1));
                dot.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
                dot.addEventListener('click', function (event) {
                    event.preventDefault();
                    event.stopPropagation();
                    setSlide(carousel, i);
                    restartTimer(carousel);
                });
                dotsHost.appendChild(dot);
            });
        }

        setSlide(carousel, 0);

        var timer = null;
        function restartTimer(target) {
            if (timer) {
                clearInterval(timer);
            }
            timer = setInterval(function () {
                if (document.hidden) {
                    return;
                }
                var current = parseInt(target.dataset.activeIndex || '0', 10) || 0;
                setSlide(target, current + 1);
            }, INTERVAL_MS);
        }

        carousel.addEventListener('mouseenter', function () {
            if (timer) {
                clearInterval(timer);
                timer = null;
            }
        });
        carousel.addEventListener('mouseleave', function () {
            restartTimer(carousel);
        });
        carousel.addEventListener('focusin', function () {
            if (timer) {
                clearInterval(timer);
                timer = null;
            }
        });
        carousel.addEventListener('focusout', function () {
            restartTimer(carousel);
        });

        restartTimer(carousel);
    }

    track.querySelectorAll('[data-yoby-carousel]').forEach(initCarousel);

    track.querySelectorAll('.yoby-showcase-slide').forEach(function (btn) {
        btn.addEventListener('click', function () {
            var slides = allSlideButtons();
            var index = slides.indexOf(btn);
            openShowcaseLightbox(index >= 0 ? index : 0);
        });
    });

    function refreshShowcaseLocale() {
        applyShowcaseLocale(showcaseLocale());
    }

    refreshShowcaseLocale();
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', refreshShowcaseLocale);
    }
    window.addEventListener('yoby:localechange', function (event) {
        var locale = event.detail && event.detail.locale ? event.detail.locale : showcaseLocale();
        applyShowcaseLocale(locale);
    });
})();
